import {InjectionToken} from '@angular/core';

export interface IGetImageService{
    getImageUrl(...param): string;
}


export const IGetImageServiceToken = new InjectionToken<IGetImageService>('IGetImageServiceToken');
